import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';
import { AuthServiceService } from 'app/Authentification/auth-service.service';
import { StorageKeys } from 'app/Shared/Constant/StorageKeys';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { ReleaseVersionService } from 'app/Shared/Services/release-version.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputOtpModule } from 'primeng/inputotp';
import { ToastModule } from 'primeng/toast';
import { first } from 'rxjs';

@Component({
  selector: 'app-sign-in',
  imports: [RouterModule, ReactiveFormsModule, CommonModule, FormsModule, ConfirmDialogModule,
    MatCardModule, MatFormFieldModule, MatInputModule, ToastModule,
    InputOtpModule, ButtonModule],
  templateUrl: './sign-in.html',
  styleUrl: './sign-in.scss',
})
export class SignIn {

  error: string = '';
  form: any = new FormGroup({ username: new FormControl(""), password: new FormControl("") });
  loginBlock = true;
  showPassword = false;
  newPasswordRequired = false;


  constructor(
    private fb: FormBuilder,
    private router: Router,
    public authenticationService: AuthServiceService,
    private userService: UserService,
    public urlsService: UrlsService,
    public constantService: ConstantService,
    public confirmationService: ConfirmationService,
    private messageService: MessageService,
    private releaseVersionService: ReleaseVersionService) {
    this.authenticationService.rememberDevice=false;
    if(this.constantService.isSessionExpired){
	    this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: "Session Expired! Please login again." });
			this.constantService.isSessionExpired = false;
		}
    this.router.navigate(['/login/sign-in']);
  }

  ngOnInit() {
    this.authenticationService.rememberDevice=false;
    this.form = new FormGroup({
      username: new FormControl("", Validators.compose([
        Validators.required,
        Validators.minLength(7)
      ])),
      password: new FormControl("", Validators.compose([
        Validators.required,
        Validators.minLength(6),
      ])),
      remember: new FormControl("")
    });
    if(this.constantService.isSessionExpired){
	    this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: "Session Expired! Please login again." });
			this.constantService.isSessionExpired = false;
		}
  }

  keyDownFunction(event: any, e: any) {
    if (event.keyCode == 13) {
      this.loginUser(e);
    }
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  goToForgotPassword() {
    this.router.navigate(['/login/forgot-password']);
  }

  loginUser(e: { username: string; password: string; }) {

    this.authenticationService.loading = true;
    const sanitizedUsername = e.username?.trim().toLowerCase();
    this.constantService.user.username = sanitizedUsername;
    this.constantService.user.email = sanitizedUsername;
    this.constantService.user.password = e.password?.trim();
    this.constantService.user.uiVersion = this.releaseVersionService.getReleaseVersion();
  
    let deviceMeta = this.constantService.getCookie(this.constantService.user.email);
    if(deviceMeta){
    this.constantService.user.deviceMeta = JSON.parse(deviceMeta);
    }

    if(e.username){

    
    this.authenticationService.mfa_login(this.constantService.user)
      .pipe(first())
      .subscribe({
        next: (result: any) => {
          if (result?.mfaRequired) {
            if (result?.type === "EMAIL_OTP") {
              this.authenticationService.loading = false;
              this.authenticationService.session = result?.session;
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: "OTP (One-Time Password) email (" + e.username + ") being sent successfully " });
              this.router.navigate(['/login/verify-otp']);
            }
          } else if (result?.newPasswordRequired) {
            this.authenticationService.loading = false;
            this.newPasswordRequired = true;
            this.authenticationService.setUserLoggedIn();
            this.authenticationService.session = result?.session;
            this.router.navigate(['/login/new-password/' + this.newPasswordRequired]);
          } else if (result?.invalidDevice){
              this.constantService.deleteCookies(this.constantService.user.email);
              this.error = "Remember Device: Your device session has expired.. Please login again!";
              this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: this.error });
              this.authenticationService.loading = false;
              this.constantService.user.deviceMeta=null;
            }
          else {
            this.authenticationService.loading = false;
            this.authenticationService.setToken(result);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.authenticationService.loading = false;
          const errorMsg: any = err?.error?.message || err?.error?.error || '';
          if (err.status === 400 || err.status === 403) {
            this.error = "Incorrect username or password"
            if (errorMsg.includes("Password attempts exceeded")) {
              this.error = "Password attempts exceeded.";
            }
            else if (errorMsg.includes("Attempt limit exceeded")) {
              this.error = "Attempt limit exceeded. Please try again later.";
            }
          } else if (err.status === 401) {
            this.error = "Session expired. Please login again.";
          } else {
            this.error = err?.error?.message || "Something went wrong.";
          }
          this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: this.error });
        }
      });
    }
  }


  CancelUser() {
    this.form.reset();
    this.authenticationService.loading = false;
    this.error = '';
    this.constantService.clearAllStorage();
  }

  public routeTo(url: string) {
    this.router.navigate([url]);
  }

  accountLockedAndDisabled(error: any) {
    let errorMessgae;
    if (error === 'Account_Locked') {
      errorMessgae = 'User ID is locked - contact administrator.'
    }
    else if (error === 'Account_Disabled') {
      errorMessgae = 'Your Account has been disabled. Please contact the administrator to enable it.'
    }
    this.confirmationService.confirm({
      message: errorMessgae,
      key: 'informationDialoge',
      acceptLabel: 'Ok',
      rejectVisible: false,
      acceptIcon: 'pi pi-check',
      acceptButtonStyleClass: "confirm-dialog-button",
      accept: () => {
      },
    });
  }

}
